'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'triangle-exclamation';
var width = 512;
var height = 512;
var aliases = [9888,"exclamation-triangle","warning"];
var unicode = 'f071';
var svgPathData = ['M4.8 421c-6.7 12.4-6.4 27.4 .8 39.5S25.9 480 40 480l432 0c14.1 0 27.1-7.4 34.4-19.5s7.5-27.1 .8-39.5L291.2 21C284.2 8.1 270.7 0 256 0s-28.2 8.1-35.2 21L4.8 421zM288 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224.6 193.7C223.3 175.5 237.7 160 256 160s32.7 15.5 31.4 33.7l-7.4 104C279 310.3 268.6 320 256 320s-23-9.7-23.9-22.3l-7.4-104z', 'M256 416a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256c18.3 0 32.7 15.5 31.4 33.7l-7.4 104C279 310.3 268.6 320 256 320s-23-9.7-23.9-22.3l-7.4-104C223.3 175.5 237.7 160 256 160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTriangleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;